import { useEffect } from 'react';
import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric as WebVitalMetric } from 'web-vitals';
import { recordMetric, isRumEnabled } from '@/lib/rum';

/**
 * Hook para coletar Web Vitals reais
 * Métricas: LCP, CLS, INP, FCP, TTFB
 * 
 * Sampling: 100% (poucos eventos, alto valor diagnóstico)
 */
export function useWebVitals(): void {
  useEffect(() => {
    // Skip se RUM desabilitado
    if (!isRumEnabled()) return;
    
    const handleVital = (metric: WebVitalMetric) => {
      recordMetric({
        type: 'web_vital',
        name: metric.name,
        value: metric.value,
        rating: metric.rating,
        context: {
          navigation_type: metric.navigationType,
          // Não incluir entries detalhadas (podem ter dados sensíveis)
        },
      });
    };

    // Registrar todos os Web Vitals
    onCLS(handleVital);
    onINP(handleVital);
    onLCP(handleVital);
    onFCP(handleVital);
    onTTFB(handleVital);
    
    // Cleanup não necessário - web-vitals registra uma vez por pageload
  }, []);
}
